// extracted by mini-css-extract-plugin
export default {"component":"l6tW05","active":"UZeMBM","content":"uAxt4o","prefix":"T5DQj6","postfix":"bQHaGh"};